import aktifHatirlama from '../content/blog/aktif-hatirlama-active-recall-teknigi.md?raw';
import calismaOrtami from '../content/blog/ders-calisma-ortami-nasil-duzenlenir.md?raw';
import prokrastinasyon from '../content/blog/prokrastinasyonu-yenmek-erteleme-aliskanligi.md?raw';
import beslenmeHidrasyon from '../content/blog/beslenme-hidrasyon-beyin-performansi.md?raw';
import zamanYonetimi from '../content/blog/zaman-yonetimi-ve-onceliklendirme-ogrenciler.md?raw';
import yksDenemeAnalizi from '../content/blog/yks-deneme-analizi-nasil-yapilir.md?raw';
import soruBankasiMakale from '../content/blog/bitmiyo-soru-bankasi-ve-dijital-test-editoru.md?raw';
import sinifPlatformuMakale from '../content/blog/bitmiyo-sinif-dijital-ogretmen-ve-okul-ekosistemi.md?raw';
import kpssPuanHesaplama from '../content/blog/kpss-puan-hesaplama-lisans-onlisans-ortaogretim.md?raw';
import agsPuanHesaplama from '../content/blog/meb-ags-puan-hesaplama-z-skor-rehberi.md?raw';
import yksPuanHesaplama from '../content/blog/yks-puan-ve-siralama-hesaplama-tyt-ayt-obp.md?raw';
import lgsPuanHesaplama from '../content/blog/lgs-puan-hesaplama-ve-yuzdelik-dilim-rehberi.md?raw';
import takdirTesekkurHesaplama from '../content/blog/takdir-tesekkur-hesaplama-ve-ortalama-yukseltme.md?raw';
import alesDgsProgrami from '../content/blog/ales-ve-dgs-sayisal-sozel-calisma-programi.md?raw';
import tytTurkce from '../content/blog/tyt-turkce-nasil-calisilir.md?raw';
import spacedRepetition from '../content/blog/aralikli-tekrar-yks-lgs.md?raw';
import yksFizikKimya from '../content/blog/yks-fizik-kimya-nasil-calisilir.md?raw';
import sosyalMedya from '../content/blog/sosyal-medya-dikkat-dagitma-ders-calisma.md?raw';
import lgsVeli from '../content/blog/lgs-velirehberi-cocuga-yardim.md?raw';
import yazKampi from '../content/blog/yks-yaz-kampi-tyt-nasil-biter.md?raw';
import uykuMakale from '../content/blog/ders-calisirken-uyku-gelirse.md?raw';
import mezunMakale from '../content/blog/mezun-yks-calisma-programi.md?raw';
import etkiliCalisma from '../content/blog/etkili-ders-calisma-teknikleri.md?raw';
import youtubeHazirlik from '../content/blog/youtube-ders-kanallari-ile-yks-hazirlik.md?raw';
import uzaktanEgitim from '../content/blog/uzaktan-egitim-ve-hibrit-ogrenme.md?raw';
import youtubePlaylist from '../content/blog/youtube-playlistlerinden-ders-programi-nasil-olusturulur.md?raw';
import yksProgrami from '../content/blog/yks-calisma-programi-nasil-hazirlanir.md?raw';
import lgsProgrami from '../content/blog/lgs-calisma-programi-ve-konu-takibi.md?raw';
import enIyiUygulamalar from '../content/blog/en-iyi-ders-planlayici-uygulamalari-2026.md?raw';
import pomodoroTeknigi from '../content/blog/pomodoro-teknigi-ile-ders-calisma.md?raw';
import alanBazliProgram from '../content/blog/tyt-ayt-calisma-programi-sayisal-sozel-esit-agirlik.md?raw';
import tytMatematik from '../content/blog/tyt-matematik-nasil-calisilir.md?raw';
import yksMotivasyon from '../content/blog/yks-motivasyon-nasil-saglanir.md?raw';
import kpssProgrami from '../content/blog/kpss-calisma-programi-youtube.md?raw';

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  description: string;
  content: string;
  coverImage: string;
  date: string;
  isoDate: string;
  readTime: string;
  author: string;
  category: string;
  tags?: string[];
}

export const blogPosts: BlogPost[] = [
  {
    id: "34",
    slug: "zaman-yonetimi-ve-onceliklendirme-ogrenciler",
    title: "Zaman Yönetimi: Öğrenciler İçin Eisenhower Matrisi ve Pratik Önceliklendirme Sistemleri",
    description: "Eisenhower Matrisi, time-blocking ve haftalık planlama ritüeliyle öğrenciler için pratik zaman yönetimi rehberi. Şimdi okuyun, sisteminizi kurun.",
    date: "22 Ağustos 2026",
    isoDate: "2026-08-22T10:00:00+03:00",
    readTime: "7 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    tags: ["zamanyonetimi", "eisenhower", "onceliklendirme", "timeblocking", "planlama"],
    coverImage: "/blog-covers/zaman-yonetimi-ve-onceliklendirme-ogrenciler.webp",
    content: zamanYonetimi
  },
  {
    id: "33",
    slug: "prokrastinasyonu-yenmek-erteleme-aliskanligi",
    title: "Prokrastinasyonu Yenmek: Ders Çalışmayı Ertelemeyi Bitiren Bilimsel Yöntemler",
    description: "Erteleme alışkanlığını bilimsel yöntemlerle yenin: 2 dakika kuralı, görev bölme, implementation intentions ile Bitmiyo'da hemen başlayın.",
    date: "21 Ağustos 2026",
    isoDate: "2026-08-21T10:00:00+03:00",
    readTime: "8 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    tags: ["prokrastinasyon", "erteleme", "verimlilik", "odaklanma", "motivasyon"],
    coverImage: "/blog-covers/prokrastinasyonu-yenmek-erteleme-aliskanligi.webp",
    content: prokrastinasyon
  },
  {
    id: "32",
    slug: "beslenme-hidrasyon-beyin-performansi",
    title: "Beslenme, Hidrasyon ve Beyin Performansı: Sınav Döneminde Zihinsel Verimi Artıran Rehber",
    description: "Sınav döneminde odaklanamıyor musun? Kan şekeri dengesi, omega-3, su tüketimi ve kafein kullanımıyla zihinsel verimini artır. Ücretsiz katıl.",
    date: "20 Ağustos 2026",
    isoDate: "2026-08-20T10:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    tags: ["beslenme", "hidrasyon", "beyinperformansi", "saglik", "sinavverimi"],
    coverImage: "/blog-covers/beslenme-hidrasyon-beyin-performansi.webp",
    content: beslenmeHidrasyon
  },
  {
    id: "31",
    slug: "ders-calisma-ortami-nasil-duzenlenir",
    title: "Etkili Ders Çalışma Ortamı Nasıl Oluşturulur? Verimi İkiye Katlayan Mekan ve Dijital Düzen Rehberi",
    description: "Dağınık masa, gürültülü oda, dolu bildirimler mi verimini düşüyor? Işıktan ergonomiye, dijital sadeleşmeye kadar adım adım rehber. Hemen dene!",
    date: "19 Ağustos 2026",
    isoDate: "2026-08-19T10:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    tags: ["calismaortami", "ergonomi", "dijitalsadelesme", "odaklanma", "verimlilik"],
    coverImage: "/blog-covers/ders-calisma-ortami-nasil-duzenlenir.webp",
    content: calismaOrtami
  },
  {
    id: "30",
    slug: "aktif-hatirlama-active-recall-teknigi",
    title: "Aktif Hatırlama (Active Recall): Sınav Netlerinizi Artıracak Bilimsel Kendini Sınama Yöntemi",
    description: "Pasif okuma yerine aktif hatırlama tekniğiyle kalıcı öğrenin. Flashcard, Leitner kutusu, boş sayfa yöntemi ve YKS/LGS örnekleriyle ücretsiz katılın.",
    date: "18 Ağustos 2026",
    isoDate: "2026-08-18T10:00:00+03:00",
    readTime: "7 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    tags: ["aktifhatirlama", "activerecall", "flashcard", "leitner", "hafizateknikleri"],
    coverImage: "/blog-covers/aktif-hatirlama-active-recall-teknigi.webp",
    content: aktifHatirlama
  },
  {
    id: "29",
    slug: "bitmiyo-soru-bankasi-ve-dijital-test-editoru",
    title: "Bitmiyo Soru Bankası: Yapay Zeka Destekli PDF Soru Tarama ve Dijital Test Editörü",
    description: "Türkiye'nin akıllı dijital soru bankası platformu soru.bitmiyo.com.tr. PDF testlerden OCR ile otomatik soru kesme, LaTeX matematik editörü ve YouTube ders planı soru entegrasyonu.",
    date: "5 Ağustos 2026",
    isoDate: "2026-08-05T11:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Araştırma",
    tags: ["sorubankasi", "testeditoru", "pdfocr", "yks", "kpss"],
    coverImage: "/blog-covers/bitmiyo-soru-bankasi-ve-dijital-test-editoru.png",
    content: soruBankasiMakale
  },
  {
    id: "28",
    slug: "bitmiyo-sinif-dijital-ogretmen-ve-okul-ekosistemi",
    title: "Bitmiyo Sınıf: Öğretmenler ve Öğrenciler İçin Akıllı Dijital Sınıf Yönetimi",
    description: "Okullar, dershaneler ve özel ders öğretmenleri için dijital sınıf platformu sinif.bitmiyo.com.tr. Ödev atama, öğrenci deneme takibi, canlı ders ve materyal paylaşımı.",
    date: "5 Ağustos 2026",
    isoDate: "2026-08-05T10:30:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    tags: ["dijitalsinif", "ogretmen", "odevtakibi", "okulekosistemi"],
    coverImage: "/blog-covers/bitmiyo-sinif-dijital-ogretmen-ve-okul-ekosistemi.png",
    content: sinifPlatformuMakale
  },
  {
    id: "27",
    slug: "kpss-puan-hesaplama-lisans-onlisans-ortaogretim",
    title: "KPSS Puan Hesaplama Rehberi 2026: KPSSP3, P93, P94 ve Branş Atamaları",
    description: "2026 KPSS Lisans P3, Önlisans P93 ve Ortaöğretim P94 puan hesaplama rehberi. Genel Yetenek ve Genel Kültür net katsayıları, standart sapma ve hemşirelik atama puanları.",
    date: "5 Ağustos 2026",
    isoDate: "2026-08-05T10:00:00+03:00",
    readTime: "7 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Puan Hesaplama",
    coverImage: "/blog-covers/kpss-puan-hesaplama-lisans-onlisans-ortaogretim.png",
    content: kpssPuanHesaplama
  },
  {
    id: "26",
    slug: "meb-ags-puan-hesaplama-z-skor-rehberi",
    title: "MEB AGS Puan Hesaplama Robotu 2026: Akademi Giriş Sınavı P1, P2 ve P3 Z-Skor Hesabı",
    description: "2026 MEB AGS puan hesaplama robotu ve ÖSYM Z-skoru formülü. P1 mesleki, P2 ÖABT ve P3 YDS puan türleri, okul öncesi ile özel eğitim branş hesaplamaları.",
    date: "5 Ağustos 2026",
    isoDate: "2026-08-05T09:30:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Puan Hesaplama",
    coverImage: "/blog-covers/meb-ags-puan-hesaplama-z-skor-rehberi.png",
    content: agsPuanHesaplama
  },
  {
    id: "25",
    slug: "yks-puan-ve-siralama-hesaplama-tyt-ayt-obp",
    title: "YKS Puan ve Sıralama Hesaplama 2026: TYT AYT Net Katsayıları ve OBP Hesabı",
    description: "2026 YKS (TYT-AYT) net ve puan hesaplama rehberi. TYT %40, AYT %60 ağırlık sistemi, OBP eklenmesi, kırık OBP ve Bitmiyo deneme net takip sistemi.",
    date: "5 Ağustos 2026",
    isoDate: "2026-08-05T09:00:00+03:00",
    readTime: "7 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Puan Hesaplama",
    coverImage: "/blog-covers/yks-puan-ve-siralama-hesaplama-tyt-ayt-obp.png",
    content: yksPuanHesaplama
  },
  {
    id: "24",
    slug: "lgs-puan-hesaplama-ve-yuzdelik-dilim-rehberi",
    title: "LGS Puan Hesaplama ve Yüzdelik Dilim Rehberi 2026: 3 Yanlış 1 Doğru MEB Katsayıları",
    description: "2026 MEB LGS puan hesaplama rehberi. 3 yanlış 1 doğru kuralı, Türkçe, Matematik, Fen 4 katsayı hesabı ve yüzdelik dilim analizi.",
    date: "5 Ağustos 2026",
    isoDate: "2026-08-05T08:30:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Puan Hesaplama",
    coverImage: "/blog-covers/lgs-puan-hesaplama-ve-yuzdelik-dilim-rehberi.png",
    content: lgsPuanHesaplama
  },
  {
    id: "23",
    slug: "takdir-tesekkur-hesaplama-ve-ortalama-yukseltme",
    title: "Takdir Teşekkür Hesaplama 2026: 5-12. Sınıf & İmam Hatip Karne Ortalaması Rehberi",
    description: "5, 6, 7, 8, 9, 10, 11 ve 12. sınıf ile İmam Hatip takdir teşekkür hesaplama rehberi. Dönem ağırlıklı ortalama hesabı ve Bitmiyo Ortalama Yükseltme Asistanı.",
    date: "5 Ağustos 2026",
    isoDate: "2026-08-05T08:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Puan Hesaplama",
    coverImage: "/blog-covers/takdir-tesekkur-hesaplama-ve-ortalama-yukseltme.png",
    content: takdirTesekkurHesaplama
  },
  {
    id: "22",
    slug: "yks-deneme-analizi-nasil-yapilir",
    title: "YKS Deneme Analizi Nasıl Yapılır? Yanlış ve Boş Sorulardan Net Arttırma Rehberi",
    description: "YKS hazırlığında netlerinizi katlayacak adım adım deneme analizi rehberi. Yanlış ve boş soruları kategoriye ayırma, eksik konu takibi ve Bitmiyo entegrasyonu.",
    date: "29 Temmuz 2026",
    isoDate: "2026-07-29T10:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/yks-deneme-analizi-nasil-yapilir.webp",
    content: yksDenemeAnalizi
  },
  {
    id: "21",
    slug: "ales-ve-dgs-sayisal-sozel-calisma-programi",
    title: "ALES ve DGS Çalışma Programı: Çalışanlar ve Mezunlar İçin YouTube Odaklı Hazırlık Rehberi",
    description: "İş veya okul temposuyla ALES ve DGS'ye hazırlananlar için özel ders çalışma programı. Sayısal/sözel mantık taktikleri ve akıllı YouTube ders takvimi.",
    date: "29 Temmuz 2026",
    isoDate: "2026-07-29T09:00:00+03:00",
    readTime: "7 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Sınav",
    coverImage: "/blog-covers/ales-ve-dgs-sayisal-sozel-calisma-programi.webp",
    content: alesDgsProgrami
  },
  {
    id: "20",
    slug: "ders-calisirken-uyku-gelirse",
    title: "Ders Çalışırken Uyku Gelirse Ne Yapmalı? Uyku ve Hafıza İlişkisi",
    description: "Ders çalışırken aniden bastıran uykuyu bilimsel yöntemlerle yenin! Uyku ve hafıza arasındaki ilişki, uykulu zihni canlandırma taktikleri ve verimli zaman yönetimi.",
    date: "4 Temmuz 2026",
    isoDate: "2026-07-04T12:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    coverImage: "/blog-covers/ders-calisirken-uyku-gelirse.webp",
    content: uykuMakale
  },
  {
    id: "19",
    slug: "mezun-yks-calisma-programi",
    title: "Mezun YKS Öğrencisi Nasıl Çalışmalı? Tam Zamanlı Hazırlık Rehberi",
    description: "Mezuna kalan YKS öğrencileri için tam zamanlı ders çalışma disiplini kurma yolları. Günlük 8-10 saatlik örnek blok ders programı ve burnout önleme stratejileri.",
    date: "4 Temmuz 2026",
    isoDate: "2026-07-04T10:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/mezun-yks-calisma-programi.webp",
    content: mezunMakale
  },
  {
    id: "18",
    slug: "yks-fizik-kimya-nasil-calisilir",
    title: "Fizik ve Kimya Nasıl Çalışılır? YKS Fen Derslerinde Net Artırma Rehberi",
    description: "Fizik ve kimya derslerinde ezberci yaklaşımı bırakıp mantığını kavrayarak netlerinizi artırın! VIP taktikler ve YouTube kanal önerileri.",
    date: "30 Haziran 2026",
    isoDate: "2026-06-30T12:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Sınav",
    coverImage: "/blog-covers/yks-fizik-kimya-nasil-calisilir.webp",
    content: yksFizikKimya
  },
  {
    id: "17",
    slug: "aralikli-tekrar-yks-lgs",
    title: "Aralıklı Tekrar Nedir? YKS ve LGS'de Nasıl Uygulanır?",
    description: "YKS ve LGS hazırlığında öğrendiklerinizi unutmamak için Ebbinghaus Unutma Eğrisi'ne dayalı bilimsel aralıklı tekrar yöntemlerini keşfedin.",
    date: "30 Haziran 2026",
    isoDate: "2026-06-30T10:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    coverImage: "/blog-covers/aralikli-tekrar-yks-lgs.webp",
    content: spacedRepetition
  },
  {
    id: "16",
    slug: "tyt-turkce-nasil-calisilir",
    title: "TYT Türkçe Nasıl Çalışılır? Paragraf Soruları ve Dil Bilgisi Stratejisi",
    description: "YKS hazırlığında en çok soru getiren TYT Türkçe'de netlerinizi sıfırdan zirveye taşıyacak paragraf hızlanma teknikleri ve dil bilgisi çalışma sırası.",
    date: "30 Haziran 2026",
    isoDate: "2026-06-30T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Rehberlik",
    category: "Sınav",
    coverImage: "/blog-covers/tyt-turkce-nasil-calisilir.webp",
    content: tytTurkce
  },
  {
    id: "15",
    slug: "sosyal-medya-dikkat-dagitma-ders-calisma",
    title: "Sosyal Medya ve Ders Çalışma: Dikkat Dağınıklığını Yenmenin 7 Yolu",
    description: "Sınav senesinde telefon bağımlılığı ve dikkat dağınıklığı nasıl yenilir? Odaklanma sürenizi artıracak 7 bilimsel ve pratik çözüm.",
    date: "29 Haziran 2026",
    isoDate: "2026-06-29T12:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Rehberlik",
    category: "Verimlilik",
    coverImage: "/blog-covers/sosyal-medya-dikkat-dagitma-ders-calisma.webp",
    content: sosyalMedya
  },
  {
    id: "14",
    slug: "lgs-velirehberi-cocuga-yardim",
    title: "LGS'ye Hazırlanan Çocuğuna Nasıl Yardım Edilir? Veli Rehberi",
    description: "LGS dönemindeki çocuğunuza baskı kurmadan nasıl destek olursunuz? Evdeki çalışma ortamını düzenleme, motivasyon sağlama ve dijital takip rehberi.",
    date: "29 Haziran 2026",
    isoDate: "2026-06-29T10:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Rehberlik",
    category: "Rehberlik",
    coverImage: "/blog-covers/lgs-velirehberi-cocuga-yardim.webp",
    content: lgsVeli
  },
  {
    id: "13",
    slug: "yks-yaz-kampi-tyt-nasil-biter",
    title: "YKS Yaz Kampı: Yaz Tatilinde TYT Nasıl Biter?",
    description: "Yaz tatilinde TYT'yi bitirmek hayal değil! Derece öğrencilerinin yaz kampı sırları, stratejik ders çalışma taktikleri ve motivasyon önerileri.",
    date: "29 Haziran 2026",
    isoDate: "2026-06-29T08:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/yks-yaz-kampi-tyt-nasil-biter.webp",
    content: yazKampi
  },
  {
    id: "12",
    slug: "kpss-calisma-programi-youtube",
    title: "KPSS Çalışma Programı Nasıl Yapılır? YouTube ile Evde Hazırlık Rehberi",
    description: "Evde kendi kendinize KPSS'ye hazırlanırken YouTube oynatma listelerinizi (playlist) nasıl organize edeceğinizi öğrenin! Adım adım KPSS çalışma rehberi.",
    date: "28 Haziran 2026",
    isoDate: "2026-06-28T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Sınav",
    coverImage: "/blog-covers/kpss-calisma-programi-youtube.webp",
    content: kpssProgrami
  },
  {
    id: "11",
    slug: "yks-motivasyon-nasil-saglanir",
    title: "YKS Motivasyonu Nasıl Sağlanır? Burnout'tan (Tükenmişlik) Çıkış Rehberi",
    description: "YKS sürecinde tükenmişlik hissini (burnout) bilimsel yöntemlerle yenin! Motivasyonunuzu artıracak, kaygı düzeyini düşürecek adım adım zihinsel sağlık rehberi.",
    date: "28 Haziran 2026",
    isoDate: "2026-06-28T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    coverImage: "/blog-covers/yks-motivasyon-nasil-saglanir.webp",
    content: yksMotivasyon
  },
  {
    id: "10",
    slug: "tyt-matematik-nasil-calisilir",
    title: "TYT Matematik Nasıl Çalışılır? Sıfırdan Zirveye Yol Haritası",
    description: "Matematik korkunuzu bilimsel yöntemlerle yenin! Sıfırdan başlayanlar ve netlerini artırmak isteyenler için adım adım pedagojik TYT Matematik çalışma rehberi.",
    date: "28 Haziran 2026",
    isoDate: "2026-06-28T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Sınav",
    coverImage: "/blog-covers/tyt-matematik-nasil-calisilir.webp",
    content: tytMatematik
  },
  {
    id: "4",
    slug: "youtube-playlistlerinden-ders-programi-nasil-olusturulur",
    title: "YouTube Playlistlerinden Ders Programı Nasıl Oluşturulur?",
    description: "YouTube'daki binlerce ders videosu arasında kaybolmayın. Kendi çalışma programınızı adım adım nasıl hazırlayacağınızı ve süreci nasıl otomatikleştireceğinizi öğrenin.",
    date: "27 Haziran 2026",
    isoDate: "2026-06-27T08:00:00+03:00",
    readTime: "6 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/youtube-playlistlerinden-ders-programi-nasil-olusturulur.webp",
    content: youtubePlaylist
  },
  {
    id: "3",
    slug: "uzaktan-egitim-ve-hibrit-ogrenme-modelleri",
    title: "Uzaktan Eğitim ve Hibrit Öğrenme Modelleri",
    description: "Türkiye'deki dijital dönüşümün yeni yüzü hibrit öğrenme. EBA istatistiklerinden üniversitelerdeki son duruma kapsamlı bir rehber.",
    date: "27 Haziran 2026",
    isoDate: "2026-06-27T08:00:00+03:00",
    readTime: "7 dk okuma",
    author: "Bitmiyo Editör",
    category: "Araştırma",
    coverImage: "/blog-covers/uzaktan-egitim-ve-hibrit-ogrenme-modelleri.webp",
    content: uzaktanEgitim
  },
  {
    id: "9",
    slug: "tyt-ayt-calisma-programi-sayisal-sozel-esit-agirlik",
    title: "TYT AYT Çalışma Programı: Sayısal, Sözel, Eşit Ağırlık",
    description: "Herkese uyan standart programları unutun! Kendi alanınıza (Sayısal, Sözel, TM) özel, stratejik ve akıllı YKS çalışma programınızı nasıl yapacağınızı keşfedin.",
    date: "26 Haziran 2026",
    isoDate: "2026-06-26T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/tyt-ayt-calisma-programi-sayisal-sozel-esit-agirlik.webp",
    content: alanBazliProgram
  },
  {
    id: "1",
    slug: "etkili-ders-calisma-teknikleri",
    title: "Pomodoro ve Ötesi: Etkili Ders Çalışma Teknikleri",
    description: "Saatlerce çalışmanıza rağmen verim alamıyor musunuz? Dünyaca kanıtlanmış çalışma teknikleri ile verimliliğinizi ikiye katlayın.",
    date: "24 Haziran 2026",
    isoDate: "2026-06-24T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/aralikli-tekrar-yks-lgs.webp",
    content: etkiliCalisma
  },
  {
    id: "8",
    slug: "pomodoro-teknigi-ile-ders-calisma",
    title: "Pomodoro Tekniği ile Ders Çalışma: Odaklanma Problemini Çözün",
    description: "Dikkat dağınıklığı yaşıyorsanız Pomodoro Tekniği tam size göre! 25 dakikalık periyotlarla YKS ve LGS çalışma veriminizi nasıl %100 artıracağınızı öğrenin.",
    date: "23 Haziran 2026",
    isoDate: "2026-06-23T08:00:00+03:00",
    readTime: "4 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Verimlilik",
    coverImage: "/blog-covers/ders-calisirken-uyku-gelirse.webp",
    content: pomodoroTeknigi
  },
  {
    id: "7",
    slug: "en-iyi-ders-planlayici-uygulamalari-2026",
    title: "En İyi Ders Planlayıcı Uygulamaları (2026)",
    description: "İşler Cepte, Bilgenç, Kunduz ve Bitmiyo... Hangi eğitim uygulamasının sizin çalışma tarzınıza en uygun olduğunu keşfedin ve karşılaştırın.",
    date: "21 Haziran 2026",
    isoDate: "2026-06-21T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/mezun-yks-calisma-programi.webp",
    content: enIyiUygulamalar
  },
  {
    id: "2",
    slug: "youtube-ders-kanallari-ile-yks-hazirlik",
    title: "YouTube Ders Kanallarıyla YKS'ye Hazırlanmak",
    description: "Sadece YouTube izleyerek üniversite kazanılır mı? Ücretsiz içeriklerle YKS sürecini nasıl yöneteceğinizi adım adım anlatıyoruz.",
    date: "20 Haziran 2026",
    isoDate: "2026-06-20T08:00:00+03:00",
    readTime: "4 dk okuma",
    author: "Bitmiyo Rehberlik",
    category: "Sınav",
    coverImage: "/blog-covers/kpss-calisma-programi-youtube.webp",
    content: youtubeHazirlik
  },
  {
    id: "6",
    slug: "lgs-calisma-programi-ve-konu-takibi",
    title: "LGS Çalışma Programı ve Konu Takibi",
    description: "8. Sınıf öğrencileri için LGS maratonunda başarıya giden yol haritası. Pomodoro tekniği, yeni nesil soru çözümü ve dijital konu takibi stratejileri.",
    date: "19 Haziran 2026",
    isoDate: "2026-06-19T08:00:00+03:00",
    readTime: "4 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/lgs-velirehberi-cocuga-yardim.webp",
    content: lgsProgrami
  },
  {
    id: "5",
    slug: "yks-calisma-programi-nasil-hazirlanir",
    title: "YKS Çalışma Programı Nasıl Hazırlanır? Adım Adım Rehber",
    description: "Sınav maratonunda kaybolmayın! Kendi seviyenize uygun, uygulanabilir ve esnek bir YKS çalışma programı hazırlamanın bilimsel yöntemleri.",
    date: "17 Haziran 2026",
    isoDate: "2026-06-17T08:00:00+03:00",
    readTime: "5 dk okuma",
    author: "Bitmiyo Ekibi",
    category: "Rehberlik",
    coverImage: "/blog-covers/yks-yaz-kampi-tyt-nasil-biter.webp",
    content: yksProgrami
  }
];
